<template>
  <div class="c-anchor-navbar c-anchor-navbar--sticky" :class="{ 'c-anchor-navbar--fixed': isFixed }" v-scroll="handleScrollThrottled">
    <div class="c-anchor-navbar__preview" v-show="!isToggled" v-text="pinnedAnchor?.name"></div>
    <div class="c-anchor-navbar__inner" :class="{ 'c-anchor-navbar__inner--toggled': isToggled }">
      <a
          href="#"
          class="c-anchor-navbar__button"
          role="button"
          v-for="anchor in anchors"
          :class="{ 'c-anchor-navbar__button--active': isActive(anchor) }"
          :key="anchor.id"
          @click="select(anchor, $event)">
        <span v-text="anchor.name"></span>
      </a>
      <a class="c-anchor-navbar__button" v-for="point in Array.isArray(additionalLinks) ? additionalLinks : []" :href="point.link">
        <span v-text="t(point.name)"></span>
      </a>
    </div>
    <div class="c-anchor-navbar__toggle" :class="{ 'c-anchor-navbar__toggle--open': isToggled }" @click="toggle"></div>
  </div>
</template>
<script lang="ts">
import throttle from 'lodash/throttle';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ScrollAnchor } from '../store/modules/ui';
import BaseComponent from './Base';

const ui = namespace('ui');

@Component
export default class AnchorNavbar extends BaseComponent {
  @ui.State('scrollAnchors') protected readonly scrollAnchors: ScrollAnchor[];
  @Prop({ type: Array, default: null }) protected readonly additionalLinks: Array<{ link: string; name: string }> | null;
  @Prop({ type: Array, default: null }) protected readonly activeAnchors: Array<{ id: string; name: string }> | null;

  protected anchors: ScrollAnchor[] = [];
  protected activeAnchor: ScrollAnchor | null = null;
  protected isFixed: boolean = false;
  protected isToggled: boolean = false;
  protected handleScrollThrottled = throttle(this.onScroll, 250, { leading: false });

  protected get pinnedAnchor(): ScrollAnchor | null {
    if (this.activeAnchor !== null) {
      return this.activeAnchor;
    }

    return this.scrollAnchors.length ? this.scrollAnchors[0] : null;
  }

  protected mounted(): void {
    const anchors: any[] = !Array.isArray(this.activeAnchors) ? this.scrollAnchors : this.scrollAnchors.map(anchor => {
      const a = (this.activeAnchors as Array<{ id: string; name: string }>).find(({ id }) => anchor.id === id) || null;

      return a ? { ...anchor, ...a } : null;
    });

    this.anchors = anchors.filter(v => v !== null);
    this.onScroll();
  }

  protected onScroll(): void {
    const { top, height } = this.$el.getBoundingClientRect();
    this.isFixed = top - height * .1 - (parseInt(getComputedStyle(this.$el).getPropertyValue('top')) || 0) <= 0;
    this.activeAnchor = this.scrollAnchors.filter(anchor => (anchor.el.elm as HTMLElement).getBoundingClientRect().top <= top + height).pop() || null;
  }

  protected toggle(): void {
    this.isToggled = !this.isToggled;
  }

  protected isActive(anchor: ScrollAnchor): boolean {
    return this.activeAnchor !== null ? anchor.id === this.activeAnchor.id : false;
  }

  protected select(anchor: ScrollAnchor, event: Event): void {
    event.preventDefault();
    this.isToggled = false;
    window.scrollTo({
      top: (anchor.el.elm as HTMLElement).offsetTop - this.$el.getBoundingClientRect().height,
      behavior: 'smooth',
    });
  }
}
</script>
